// import { useMediaQuery } from '@material-ui/core';
// import { useHistory } from 'react-router-dom';
// import styled from 'styled-components/macro';
// import Subheading from 'app/shared/components/typography/subheading/Subheading';
// import { useShowInfo } from 'app/shared/context-hooks/use-show-info.hook';
// import {
//   useEffectOnChanges,
//   useObservableBinding,
//   useUrlParams,
//   useWatchAsRef,
// } from 'app/tools/hooks/misc-hooks';
// import {
//   useAssignProductBlank,
//   useAssignedProduct,
//   useAssignedProductsLite,
//   useDeleteAssignedProduct,
//   useSetAssignedProductCustomImg,
// } from 'app/core/api/product-assignment/api-product-assignment';
// // import { useAssignmentOpenRepair } from 'app/core/api/repairer/api-repairer';
// import AppImage from 'app/shared/components/app-image/AppImage';
// import EditableImage from 'app/shared/components/app-image/EditableImage';
// import { ProductPictureFallback } from 'app/shared/components/app-image/ProductPictureOrDefault';
// import SharedRoutePath from 'app/shared/SharedRoutePath';
// import _ from 'lodash';
// import { getErrorMsg } from 'app/core/errors/error-utils';
// import styledFuncs from 'app/styles/styledFuncs';
// import Button from 'app/shared/components/button/Button';
// import ClassName from 'app/styles/ClassName';
// import { productImg } from 'app/core/api/product-assignment/api-product-assignment.types';
// import { useQueryParams } from 'app/tools/hooks/misc-hooks';

// const StyledSubheading = styled(Subheading)`
//   opacity: 0.75;
// `;
// const CompactButton = styled(Button).attrs({
//   slim: true,
//   className: ClassName.NO_HEIGHT_MARGIN,
// })`
//   margin-top: ${styledFuncs.pad()};
//   margin-bottom: ${styledFuncs.pad(0.5)};
// `;

// const SQUARE_BTN_WIDTH_VAL = 50;
// const GRP_LEFT_BTN_BREAKPOINT = '(min-width: 340px)';

export default function ProductDetails(): JSX.Element {
  // const id = +useUrlParams(['id']).id;
  // const history = useHistory();
  // const { showDialog, showSnack } = useShowInfo();
  // const { request$: assignProductBlank$ } = useAssignProductBlank();
  // const {
  //   resource: asgnProductsLite,
  //   request: refreshAsgnProductsLite,
  // } = useAssignedProductsLite();
  // const {
  //   resource: asgnProductOrLite = _.find(asgnProductsLite, { id }),
  //   request: refreshAsgnProduct,
  //   loading: loadingAsgnProduct,
  //   error,
  // } = useAssignedProduct(id, { fresh: true });
  // const { request$: setProductImg$, sending: settingImg } =
  //   useSetAssignedProductCustomImg();
  // const { request$: deleteAssignedProduct$, sending: deletingImg } =
  //   useDeleteAssignedProduct();
  // // const { resource: openRepairCaseId, loading: loadingOpenCase } =
  // //   useAssignmentOpenRepair(id);

  // const { productDetails: product, warrantyDetails: warranty } =
  //   asgnProductOrLite || {};

  // const handleImageSelect = (img: File | null) => {
  //   setProductImg$({
  //     id,
  //     data: { userProductImage: img ?? undefined },
  //   }).subscribe(() => {
  //     refreshAsgnProduct();
  //     refreshAsgnProductsLite();
  //   });
  // };
  // const handleImageSelectRef = useWatchAsRef(handleImageSelect);

  // const handleDeleteSuccess = () => {
  //   showSnack({
  //     message: 'Product deleted',
  //     alertType: 'success',
  //   });
  //   history.replace(SharedRoutePath.HOME);
  // };

  // const handleDeleteError = (e: unknown) => {
  //   showSnack({ message: getErrorMsg(e), alertType: 'error' });
  // };

  // const deleteConfirmCallback = () =>
  //   deleteAssignedProduct$(id).subscribe({
  //     next: handleDeleteSuccess,
  //     error: handleDeleteError,
  //   });

  // const handleDeleteRequest = () =>
  //   showDialog({
  //     title: 'Delete assigned product',
  //     message:
  //       'Are you sure you want to delete this entry? You will lose the personal information associated with this product.',
  //     actions: [
  //       { text: 'Cancel' },
  //       {
  //         text: 'Confirm Delete',
  //         callback: () => {
  //           deleteConfirmCallback();
  //         },
  //       },
  //     ],
  //   });
  // const spinnerStyling = useMediaQuery(GRP_LEFT_BTN_BREAKPOINT)
  //   ? { marginLeft: '8px', marginRight: '0px' }
  //   : {};
  // const [imageSet, imageSet$] = useObservableBinding<File | null>(
  //   null
  // );

  // useEffectOnChanges(() => {
  //   handleImageSelectRef.current(imageSet);
  // }, [handleImageSelectRef, imageSet]);

  // const removeImage = () => {
  //   handleImageSelect(null);
  //   refreshAsgnProduct();
  //   refreshAsgnProductsLite();
  // };
  return (
    <>
      {/* <StyledSubheading>{product?.name}</StyledSubheading>
      {asgnProductOrLite?.productDetails?.source ===
      'manual_input' ? (
        <EditableImage
          alt={product?.name || 'product'}
          imageSet$={imageSet$}
          currentSrc={productImg(asgnProductOrLite)}
          loadingImg={!asgnProductOrLite || settingImg || deletingImg}
          usedCustomImg={!!asgnProductOrLite?.userProductImage}
          fallbackImgNode={<ProductPictureFallback height="180px" />}
          classes={{ img: 'rounded', appImage: 'h-[180px]' }}
          removeImage={removeImage}
        />
      ) : (
        <div style={{ margin: '0 auto' }}>
          <AppImage
            alt="profile image"
            src={asgnProductOrLite?.productDetails?.imageUrl}
            fallbackImgNode={
              <ProductPictureFallback height="180px" />
            }
            height="180px"
            noPad
            className="mb-1.5 w-10 h-10 rounded"
          />
        </div>
      )}
      <CompactButton
        variant="outlined"
        // to={
        //   openRepairCaseId
        //     ? `${SharedRoutePath.CHAT}/${openRepairCaseId}`
        //     : `${ConsumerRoutePath.PRODUCT_REPORT_FAULT}/${id}`
        // }
        // pending={loadingOpenCase}
      >
        Add to wallet and repair
      </CompactButton>
      <CompactButton
      // to={
      //   openRepairCaseId
      //     ? `${SharedRoutePath.CHAT}/${openRepairCaseId}`
      //     : `${ConsumerRoutePath.PRODUCT_REPORT_FAULT}/${id}`
      // }
      // pending={loadingOpenCase}
      >
        Add to wallet
      </CompactButton> */}
    </>
  );
}
